module.exports = __webpack_public_path__ + "static/media/finger_closed_update.10a4c2a7.svg";